export const isMyCcpSubdomain = () => {
    return window.location.hostname.startsWith('myccp.');
}
